import { render } from "./UserFragment.vue?vue&type=template&id=150652a6&scoped=true"
import script from "./UserFragment.vue?vue&type=script&lang=js"
export * from "./UserFragment.vue?vue&type=script&lang=js"

import "./UserFragment.vue?vue&type=style&index=0&id=150652a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150652a6"]])

export default __exports__